export const addresses = {
  token: "0xf2b75BE22fd865f7dE4C30f8654CE041Bd1e2FF2",
};
